module.exports = __webpack_public_path__ + "static/media/floor1.6ce1409e.png";